<div class="register-wrapper">
    <div class="register-panel" *ngIf="isCoach == null">
        <div style="text-align: center;"><img alt="Rack Coach" src="/Images/logo-rackcoach-black.png" 
            style="margin-bottom: 50px" class="img img-responsive rack-logo" /></div>
        <div class="reg-header-font" style="margin-bottom: 20px">Select Your Account Type</div>
        <div class="reg-subheader" style="margin-bottom: 60px">
            Coaches can register their account directly.<br />
            Athletes must register through the mobile application using an invite code supplied by their coach.
        </div>
        <div style="display: flex; justify-content: center; flex-wrap: wrap">
            <div style="margin: 0 50px">
                <div class="reg-header-font" style="margin-bottom: 2px">Coach</div>
                <button class="account-type-btn primary"
                        color="primary" 
                        (click)="isCoach = true;"
                        style="width: 330px;"
                        >Begin Registration</button>
            </div>
            
            <div style="margin: 0 50px">
                <div class="reg-header-font">Athlete</div>
                <div style="display: flex">
                    <a href='https://play.google.com/store/apps/details?id=com.rack.performance' target="_blank">
                        <img style="width: 165px; margin-top: 1px" alt='Get it on Google Play' 
                            src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                    </a>
                    <a href='https://apps.apple.com/us/app/rackcoach/id1060795832' target="_blank">
                        <img style="width: 130px; margin: 11px" alt='Get it on Apple App Store' 
                            src='/Images/app-store-badge.svg'/>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isCoach" class="register-panel">
        <div style="text-align: center;"><img alt="Rack Coach" src="/Images/logo-rackcoach-black.png" class="img img-responsive rack-logo" /></div>

        <ng-container *ngIf="currentStep === 'register'">
            <form class="register-form" [formGroup]="stepOne">
                <div class="auth-title" style="margin-bottom: 30px;">Register Your Account</div>
                <ng-container *ngIf="!accountAlreadyRegistered">
                    <div class="full-width" style="display: flex; align-items: center;">
                        <div class="half-width" style="margin-right: 2%;">
                            <input class="rounded-input"
                                [class.invalid-input]="!isFieldValid.firstName"
                                (change)="getFormValidationErrors('firstName')"
                                placeholder="First Name"
                                formControlName="firstName"
                                required>
                        </div>
                        <div class="half-width">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.lastName" (change)="getFormValidationErrors('lastName')" placeholder="Last Name" formControlName="lastName" required>
                        </div>
                    </div>
                    <div class="full-width">
                        <input class="rounded-input" [class.invalid-input]="!isFieldValid.email" (change)="getFormValidationErrors('email')" (blur)="checkIfUserExists()" placeholder="Email Address" formControlName="email" required>
                    </div>
                    <div class="full-width" style="display: flex; align-items: center;">
                        <div class="half-width" style="margin-right: 2%">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.phone" (change)="getFormValidationErrors('phone')" placeholder="Phone" formControlName="phone" mask="(000) 000-0000" required>
                        </div>
                        <div class="half-width">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.zip" (change)="getFormValidationErrors('zip')" placeholder="Zip Code" formControlName="zip" maxlength="10" required>
                        </div>
                    </div>
                    <div class="full-width rc-password-columns" style="display: flex; align-items: center;">
                        <div class="half-width" style="margin-right: 2%">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.password" (change)="getFormValidationErrors('password')" type="password" placeholder="Password" formControlName="password" data-password-feedback autocomplete="new-password" required>
                        </div>
                        <div class="half-width">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.confirmPassword" (change)="getFormValidationErrors('confirmPassword')" type="password" placeholder="Confirm Password" formControlName="confirmPassword" data-password-confirm autocomplete="new-password" required>
                        </div>
                    </div>  
                </ng-container>
                
                
                
                
                <ng-container *ngIf="selectedOrgSchool">
                    <h3 style="text-align: center">Does this look correct?</h3>
                    <mat-card>
                        <div style="font-weight: bold">{{selectedOrgSchool.Name}}</div>
                        <div *ngIf="selectedOrgSchool.Address1">
                            {{selectedOrgSchool.Address1}}
                        </div>
                        <div *ngIf="selectedOrgSchool.Address2">
                            {{selectedOrgSchool.Address2}}
                        </div>
                        <div *ngIf="selectedOrgSchool.Location">
                            {{selectedOrgSchool.Location}}
                        </div>
    
                    </mat-card>
                    <div style="margin: 15px 0; text-align: center">
                        <a (click)="selectedOrgSchool = null">No, clear my selection</a>
                    </div>
                </ng-container>
                <ng-container *ngIf="!selectedOrgSchool">
                    <div *ngIf="!isCommunityRegistration" class="full-width">
                        <ng-mat-autocomplete class="printhide" 
                            [service]="schoolService"
                            [serviceParams]="searchParams"
                            [displayTemplate]="schoolDisplayTemplate"
                            [placeholder]="'School Name'"
                            displayItem="item.Name"
                            [initialQuery]="stepOne.value.schoolName"
                            [class.invalid-mat-autocomplete]="!isFieldValid.schoolName" 
                            (optionSelected)="selectSchool($event)"
                            (queryChanged)="setSchoolName($event)">
                        </ng-mat-autocomplete>
                    </div>
                    <div *ngIf="!accountAlreadyRegistered" class="full-width" style="margin-bottom: 10px">
                        <mat-checkbox class="example-margin auth-subtitle" color="primary" (change)="isCommunityRegistration = $event.checked">
                            I'm not currently at a school but would like to join the community
                        </mat-checkbox>
                    </div>
                    <ng-container *ngIf="isCommunityRegistration === false">
                        <div class="full-width">
                            <select class="rounded-input" formControlName="country">
                                <option *ngFor="let c of countries" [value]="c.name">
                                    {{c.name}}
                                </option>
                            </select>
                        </div>
                        <div class="full-width">
                            <input class="rounded-input" placeholder="Address Line 1" formControlName="address1">
                        </div>
                        <div class="full-width">
                            <input class="rounded-input" placeholder="Address Line 2" formControlName="address2">
                        </div>
                        <div class="full-width">
                            <input class="rounded-input" placeholder="City" formControlName="city">
                        </div>
                        <div *ngIf="stepOne.value.country != 'United States'" class="full-width">
                            <input class="rounded-input" placeholder="Province" formControlName="state">
                        </div>
                        <div *ngIf="stepOne.value.country == 'United States'" class="full-width">
                            <select class="rounded-input" formControlName="state" [style.color]="stepOne.value.state ? null : 'gray'">
                                <option value="" disabled selected hidden>Select State</option>
                                <option style="color: black" *ngFor="let s of states" [value]="s.abbreviation">
                                    {{s.name}}
                                </option>
                            </select>
                        </div>
                        <div class="full-width">
                            <input class="rounded-input" placeholder="Zip Code" 
                            formControlName="zipCode" maxlength="10" (focusout)="setSearchParams()">
                        </div>
                    </ng-container>
                    
                </ng-container>
                <mat-checkbox class="example-margin auth-subtitle" style="margin-top: 10px" color="primary" formControlName="agreed">
                    I agree to the RackCoach&nbsp; 
                    <a target="_new" style="color: #2196f3;" 
                        href="/Home/LicenseAgreement">Terms of Service</a>,&nbsp;
                    <a style="color: #2196f3;" target="_new" 
                        href="/Home/UserAgreement">User Terms of Use</a>&nbsp;and&nbsp;
                    <a style="color: #2196f3;"
                        target="_new" href="/Home/Privacy">Privacy Policy</a>
                </mat-checkbox>
                <div class="full-width error-text" *ngIf="registrationErrorMessage">
                    {{registrationErrorMessage}}
                </div>
                <div>
                    <button type="submit" class="primary" style="margin-top: 10px;" color="primary" (click)="registerUser()">
                        <span *ngIf="!accountAlreadyRegistered">Register and&nbsp;</span>Continue
                    </button>
                </div>
            </form>

        </ng-container>

      
        <div *ngIf="currentStep === 'select-subscription'">
            <div class="subscription-container">
                <div>
                    <table [class]="'subscription-table selected-' + selectedSubscription.Name.toLowerCase()">
                        <thead>
                            <tr *ngIf="isMobileWidth">
                                <th colspan="3" class="sub-name">
                                    <div>Choose Your subscription</div>
                                </th>
                            </tr>
                            <tr>
                                <th *ngIf="!isMobileWidth" class="sub-name">
                                    <div>Choose Your subscription</div>
                                </th>
                                <th>
                                    <div class="sub-name">Free</div>
                                    <div class="sub-heading">Get Started</div>
                                </th>
                                <th>
                                    <div class="sub-name">Essential</div>
                                    <div class="sub-heading">Game Changing Timers</div>
                                </th>
                                <th>
                                    <div class="sub-name">Pro</div>
                                    <div class="sub-heading">Data Display</div>
                                </th>
                            </tr>
                            <tr *ngIf="isMobileWidth">
                                <th colspan="3" class="choose-text">
                                    Gain control, efficiency & elevate your program.<br />
                                    <strong>Upgrade subscriptions at any time.</strong>
                                </th>
                            </tr>
                            <tr>
                                <th *ngIf="!isMobileWidth" class="choose-text">
                                    Gain control, efficiency & elevate your program.<br />
                                    <strong>Upgrade subscriptions at any time.</strong>
                                </th>
                                <th>
                                    <button (click)="selectSubscription(subscriptionTypes[0])"
                                            [class.selected]="selectedSubscription.Name === 'Free'">
                                        <i *ngIf="!isMobileWidth && selectedSubscription.Name === 'Free'" class="material-icons"> task_alt </i>
                                        SELECT<span *ngIf="selectedSubscription.Name === 'Free'">ED</span>
                                    </button>
                                </th>
                                <th>
                                    <button [class.selected]="selectedSubscription.Name === 'Essential'"
                                            (click)="selectSubscription(subscriptionTypes[1])">
                                        <i *ngIf="!isMobileWidth && selectedSubscription.Name === 'Essential'" class="material-icons"> task_alt </i>
                                        SELECT<span *ngIf="selectedSubscription.Name === 'Essential'">ED</span>
                                    </button>
                                </th>
                                <th>
                                    <button [class.selected]="selectedSubscription.Name === 'Pro'" 
                                        (click)="selectSubscription(subscriptionTypes[2])">
                                            <i *ngIf="!isMobileWidth && selectedSubscription.Name === 'Pro'" class="material-icons"> task_alt </i>
                                            SELECT<span *ngIf="selectedSubscription.Name === 'Pro'">ED</span>
                                    </button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td *ngIf="!isMobileWidth">
                                    Annual Price
                                </td>
                                <td class="text-center">
                                    $0/year
                                </td>
                                <td class="text-center">
                                    $1250/year
                                </td>
                                <td class="text-center">
                                    $1750/year
                                </td>
                            </tr>
                            
                            <ng-container *ngIf="showFeatures">
                                <ng-container *ngFor="let feature of mainFeatures">
                                    <tr *ngIf="isMobileWidth">
                                        <td class="mobile-feature" colspan="3">
                                            {{feature.name}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td *ngIf="!isMobileWidth">
                                            {{feature.name}}
                                        </td>
                                        <td class="text-center">
                                            <mat-icon *ngIf="feature.free">done</mat-icon>
                                            <span *ngIf="!feature.free">&#8212;</span>
                                        </td>
                                        <td class="text-center">
                                            <mat-icon *ngIf="feature.essential">done</mat-icon>
                                            <span *ngIf="!feature.essential">&#8212;</span>
                                        </td>
                                        <td class="text-center">
                                            <mat-icon *ngIf="feature.pro">done</mat-icon>
                                            <span *ngIf="!feature.pro">&#8212;</span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <tr>
                                <td style="text-align: center" [attr.colspan]="isMobileView ? 3 : 4">
                                    <a (click)="showFeatures = !showFeatures">
                                        <span *ngIf="!showFeatures">Show</span>
                                        <span *ngIf="showFeatures">Hide</span>
                                        Features
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="margin-bottom: 20px;" class="subscription-table team-manager" [class.team-manager-selected]="isTeamManagerSelected">
                        <thead>
                            <tr *ngIf="isMobileWidth">
                                <th colspan="2">
                                    <div class="sub-name">
                                        Choose Your Subscription
                                    </div>
                                    <div class="choose-text">
                                        Ditch the paper and manage all aspects of your team in one view.
                                        <a target="_blank" href="https://rackcoach.com/team-manager">Learn more about Team Manager’s Features</a>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th *ngIf="!isMobileWidth">
                                    <div class="sub-name">
                                        Choose Your Subscription
                                    </div>
                                    <div class="choose-text">
                                        Ditch the paper and manage all aspects of your team in one view.
                                        <a target="_blank" href="https://rackcoach.com/team-manager">Learn more about Team Manager’s Features</a>
                                    </div>
                                </th>
                                <th [attr.colspan]="isMobileWidth ? 2 : 1">
                                    <div class="sub-name">Team Manager</div>
                                    <div class="sub-heading">14-Day Free Trial</div>
                                </th>

                            </tr>
                            <tr>
                                <th *ngIf="!isMobileWidth">
                                    
                                </th>
                                <th [attr.colspan]="isMobileWidth ? 2 : 1">
                                    <button [class.selected]="isTeamManagerSelected" (click)="selectTeamManager()">
                                        <i *ngIf="isTeamManagerSelected" class="material-icons"> task_alt </i>
                                        SELECT<span *ngIf="isTeamManagerSelected">ED</span>
                                    </button>
                                    <div class="team-selector">
                                        <div style="display: flex; flex-direction: column;">
                                            <mat-icon (click)="incrementTeamCount(false)" class="cursor-pointer">expand_less</mat-icon>
                                            <mat-icon (click)="incrementTeamCount(true)" class="cursor-pointer">expand_more</mat-icon>
                                        </div>
                                        <div class="team-count">{{teamCount}}</div>
                                        <div class="team-label">TEAM<span *ngIf="teamCount != 1">S</span></div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    Annual Price
                                </td>
                                <td class="text-center">
                                    $300/Team/Year
                                </td>
                            </tr>
                            
                            <ng-container *ngIf="showTeamManagerFeatures">
                                <tr *ngFor="let feature of teamManagerFeatures">
                                    <td>
                                        {{feature.name}}
                                    </td>
                                    <td class="text-center">
                                        <mat-icon>done</mat-icon>
                                    </td>
                                </tr>
                            </ng-container>
                            <tr>
                                <td style="text-align: center" colspan="2">
                                    <a (click)="showTeamManagerFeatures = !showTeamManagerFeatures">
                                        <span *ngIf="!showTeamManagerFeatures">Show</span>
                                        <span *ngIf="showTeamManagerFeatures">Hide</span>
                                        Features
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                

                <div class="selected-column">
                    <div style="position: sticky; top: 10px">
                        <div class="your-subscriptions">
                            <div class="selected-sub-item sub-header">
                                Your Subscriptions
                            </div>
                            <div class="selected-sub-item">
                                <div class="space-between" style="margin-bottom: 10px">
                                    <div class="bold">RackCoach {{selectedSubscription.Name}}</div>
                                    <div>${{selectedSubscription.AnnualPrice}}</div>
                                </div>
                                <div *ngIf="selectedSubscription.Name !== 'Free'" class="sub-details">
                                    {{selectedSubscription.TrialExpiryDate}}
                                </div>
                                <div *ngIf="selectedSubscription.Name == 'Free'" class="sub-details">
                                    Free Subscription
                                </div>
                            </div>
                            <div *ngIf="isTeamManagerSelected" class="selected-sub-item">
                                <div class="space-between" style="margin-bottom: 10px">
                                    <div class="bold">Team Manager x {{teamCount}}</div>
                                    <div>{{teamCount}} x ${{teamManagerPrice}}</div>
                                </div>
                                <div class="sub-details">
                                    Trialing through {{expiryDateString}}
                                </div>
                            </div>
                            <div *ngIf="offerDetails && isOfferApplicable" class="selected-sub-item">
                                <div class="space-between">
                                    <div class="bold">Promo Code: {{offerCode}}</div>
                                    <div *ngIf="offerDetails.DiscountAmount">-${{offerDetails.DiscountAmount}}</div>
                                </div>
                                <div class="sub-details">
                                    {{offerDetails.Description}}
                                </div>
                            </div>
                            <div *ngIf="totalPrice > 0" class="selected-sub-item">
                                <div *ngIf="getNextBillingDate()" class="future-total">
                                    {{getNextBillingDate()}}
                                </div>
                                <div class="space-between">
                                    <div class="next-billing">
                                        <span *ngIf="!payInAdvance">Projected Future&nbsp;</span>Total
                                    </div>
                                    <div class="next-billing" style="text-align: right">
                                        ${{totalPrice}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="payment-container">
                            Enrollment below 300 students? <a href="mailto:sales@rackcoach.com">Contact Us</a> for Small School Pricing.
                        </div>
                        <div *ngIf="totalPrice > 0" class="payment-container">
                            No Payment is required at this time. When we earn your business, 
                            you can select the products you would like to purchase at that time.<br />   
                            <ng-container *ngIf="!isMainSubFreeShortTerm">
                                <a *ngIf="!payInAdvance" (click)="payInAdvance = true">I’d like to pay in advance</a>
                                <a *ngIf="payInAdvance" (click)="payInAdvance = false">I'll complete my trial first</a>
                            </ng-container>              
                            
    
                        </div>
                        <div *ngIf="payInAdvance && totalPrice > 0" class="payment-container">
                            <ngx-stripe-card
                                containerClass="stripe-input"
                                [options]="cardOptions"
                                [elementsOptions]="elementsOptions">
                            </ngx-stripe-card>
                        </div>
                        <button (click)="submitSelectSubscription()" style="margin-top: 10px" class="primary">
                            <i class="material-icons"> task_alt </i>
                            <span *ngIf="payInAdvance">Add Subscriptions & Continue</span>
                            <span *ngIf="!payInAdvance">Begin Free Trial</span>
                        </button>
                    </div>
                    
                </div>
            </div>
            
        </div>

        <form *ngIf="currentStep == 6" [formGroup]="loginForm">
            <div class="header" style="margin-bottom: 10px">Your account already exists! Log in to continue</div>
            <div class="full-width">
                <input class="rounded-input" placeholder="Email Address" formControlName="email" required>
            </div>
            <div class="full-width">
                <input class="rounded-input" type="password" placeholder="Password" formControlName="password" required>
            </div>
            
            <div style="color: red" *ngIf="showIncorrectPasswordError">
                Username or password was incorrect. Please try again.
            </div>
            <div>
                <button type="submit" class="register-button" (click)="login()" color="primary" mat-raised-button>Login</button>
            </div>
            <div style="margin: 25px 0">
                <a class="forgot-link" href="/Account/ForgotPassword" target="_blank">Forgot your password?</a>
            </div>
            <a class="forgot-link" style="cursor: pointer; font-weight: bold; font-size: 14px" (click)="reregister()">
                Register a new account
            </a>
        </form>


        <div *ngIf="currentStep == 4" style="font-size: 24px; width: 90%;">
            Good news! It looks like your school already has a Rack Subscription! The account administrator at your school is <b>{{existingUserName}}</b>. <br /> Please contact this person to get added to the account. If you believe that this is in error,
            please contact us at support@rackperformance.com or (913) 735-0090.
        </div>
        <div *ngIf="currentStep === 'sso-required'" style="width: 75%; text-align: center">
            <div class="auth-title" style="margin-bottom: 20px;">Your school uses single sign-on</div>
            <div style="font-size: 18px; margin-bottom: 30px;">
                Your account is ready — your school signs in to RackCoach with its own school accounts,
                so there's no password step here. Choose Sign in with SSO and use your school account to continue.
            </div>
            <button class="primary" (click)="window.location.href = ssoStartUrl">Sign in with SSO</button>
        </div>

        <div *ngIf="currentStep == 7" style="font-size: 24px; width: 75%; text-align: center">
            An account already exists with this e-mail address, but there was a problem continuing with your registration. Please contact us at <a href="mailto:support@rackperformance.com">support@rackperformance.com</a> or call us at (913) 735-0090 for
            assistance.
        </div>

    </div>
</div>



<ngx-spinner template="<img src='/Content/images/loader.png' />"></ngx-spinner>

<ng-template #schoolDisplayTemplate let-item>
    <b>{{item.Name}}</b> | {{item.Location}}
</ng-template>
